import { Icon } from '@/components/Icon';
import { NewsletterSignupProps } from '@/components/NewsletterSignup';

export const newsletterIntegrityDescription = `
Ja, jag samtycker och vill gärna få nyheter, marknadsföring, erbjudanden och inbjudningar till specialevenemang inom skönhet, mat, resor mm. via e-post eller sms från Aller Media AB. E-post och sms kan också innehålla nyheter, marknadsföring och erbjudanden från våra samarbetspartners. Vill du sluta få dessa e-post eller sms kan du trycka "Avregistrera" i nyhetsbrevet eller sms. För att få veta mer om hur Aller Media AB behandlar dina uppgifter kan du läsa vår <a target="_blank" href="https://www.aller.se/integritetspolicy/">integritetspolicy</a>.
</br>
</br>
Notera att du som redan är kund/prenumerant hos Aller Media AB fortsatt kommer att få marknadsföringsutskick för våra produkter enligt våra <a target="_blank" href="https://www.aller.se/allmanna-villkor/">allmänna villkor</a> och <a target="_blank" href="https://www.aller.se/integritetspolicy/">integritetspolicy</a>.
`;

export const standaloneNewsletterSignupDefaults: Omit<NewsletterSignupProps, 'options'> = {
  error: 'Tyvärr, registreringen för nyhetsbrev misslyckades. Försök igen senare.',
  description: `Håll dig uppdaterad om det senaste inom resor och äventyr. Vi skickar dig tips och råd om hur du får den perfekta resan!`,
  headline: `Skaffa vårt nyhetsbrev!`,
  inputs: {
    checkboxes: [
      {
        $standalone: { label: `Äventyrsbrevet`, name: 'newsletter', value: 'lorem' },
        rules: { required: '* Välj ett eller flera nyhetsbrev' },
      },
      {
        $standalone: { label: `Allt om resor`, name: 'newsletter', value: 'ipsum' },
        rules: { required: '* Välj ett eller flera nyhetsbrev' },
      },
    ],
    fields: [
      {
        $standalone: {
          label: `Förnamn`,
          name: 'firstname',
          options: { variant: 'secondary' },
        },
        rules: { required: 'Detta fält är obligatoriskt' },
      },
      {
        $standalone: {
          label: `Efternamn`,
          name: 'lastname',
          options: { variant: 'secondary' },
        },
        rules: { required: 'Detta fält är obligatoriskt' },
      },
      {
        $standalone: {
          label: `E-post`,
          name: 'email',
          options: { $input: { type: 'email' }, variant: 'secondary' },
        },
        rules: { required: 'Kontrollera att e-postadressen är rätt' },
      },
    ],
  },
  submitButton: { content: `Ja tack!` },
  successModal: {
    content: `<h2>Vad kul!</h2><p>Du är nu anmäld till vårt nyhetsbrev.</p>`,
    icon: <Icon name="sent" options={{ size: 'large' }} />,
  },
};
